<form [formGroup]="trackPatientResultsFilterForm" (ngSubmit)="onSubmit(submitType)" [id]="baseId + '-form'"
  class="emds result-status-filter-modal-container">
  <div class="modal-default modal-flex">
    <div class="modal-header">
      <span>{{ title }}</span>
    </div>

    <div class="modal-body">
      <div [formGroup]="trackPatientResultsFilterForm" class="form-group">
        <div class="emds-row">
          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-status'" translate>Status</label>
            <ap-findcontrol [baseId]="baseId + '-status'" findControlId="ListObservationOrderResultStatus"
              [apFormGroup]="trackPatientResultsFilterForm" controlName="Status">
            </ap-findcontrol>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-laboratory'" translate>Laboratory</label>
            <ap-findcontrol [baseId]="baseId + '-laboratory'" findControlId="ListLaboratory"
              [apFormGroup]="trackPatientResultsFilterForm" controlName="Laboratory">
            </ap-findcontrol>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-results'" translate>Results</label>
            <ap-findcontrol [baseId]="baseId + '-results'" findControlId="ListMisc"
              [apFormGroup]="trackPatientResultsFilterForm" controlName="Results"
              [requiredSearchParameters]="resultSearchParameters">
            </ap-findcontrol>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-accession-number'" translate>Accession Number</label>
            <input [id]="baseId + '-accession-number'" type="text" class="form-control"
              formControlName="AccessionNumber" maxlength="25">
          </div>
        </div>

        <div class="emds-row mt-3">
          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-patient'" translate>Patient</label>
            <ap-findcontrol [baseId]="baseId + '-patient'" findControlId="ViewFindPatient"
              [apFormGroup]="trackPatientResultsFilterForm" controlName="Patient" [disabled]="true">
            </ap-findcontrol>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-patient-city'" translate>Patient City</label>
            <input [id]="baseId + '-patient-city'" type="text" class="form-control" formControlName="PatientCity"
              readonly>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-patient-state'" translate>Patient State</label>
            <input [id]="baseId + '-patient-state'" type="text" class="form-control" formControlName="PatientState"
              readonly>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-patient-zip'" translate>Patient Zip</label>
            <input [id]="baseId + '-patient-zip'" type="text" class="form-control" formControlName="PatientZip"
              readonly>
          </div>
        </div>

        <div class="emds-row mt-3">
          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-urgency'" translate>Urgency</label>
            <ap-findcontrol [baseId]="baseId + '-urgency'" findControlId="ListMessageUrgency"
              [apFormGroup]="trackPatientResultsFilterForm" controlName="Urgency">
            </ap-findcontrol>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-template'" translate>Template</label>
            <ap-findcontrol [baseId]="baseId + '-template'" findControlId="ListObservation"
              [apFormGroup]="trackPatientResultsFilterForm" controlName="Template"
              [additionalSearchParameters]="templateSearchParameters">
            </ap-findcontrol>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-attachment-type'" translate>Attachment Type</label>
            <ap-findcontrol [baseId]="baseId + '-attachment-type'" findControlId="ListAttachmentType"
              [apFormGroup]="trackPatientResultsFilterForm" controlName="AttachmentType">
            </ap-findcontrol>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-order-date'" translate>Order Date</label>
            <ap-timespan-find-control [baseId]="baseId + '-order-date'" [findControlId]="'ListTimespan'"
              [(selectedPks)]="orderDateSelectedPks" [singleSelect]="true"
              (selectedPksChange)="onOrderDateChanged($event)">
            </ap-timespan-find-control>
          </div>
        </div>

        <div class="emds-row mt-3">
          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-due-date'" translate>Due Date</label>
            <ap-timespan-find-control [baseId]="baseId + '-due-date'" [findControlId]="'ListTimespan'"
              [(selectedPks)]="dueDateSelectedPks" [singleSelect]="true" (selectedPksChange)="onDueDateChanged($event)">
            </ap-timespan-find-control>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-result-date'" translate>Result Date</label>
            <ap-timespan-find-control [baseId]="baseId + '-result-date'" [findControlId]="'ListTimespan'"
              [(selectedPks)]="resultDateSelectedPks" [singleSelect]="true"
              (selectedPksChange)="onResultDateChanged($event)">
            </ap-timespan-find-control>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-provider'" translate>Provider</label>
            <ap-findcontrol [baseId]="baseId + '-provider'" findControlId="ViewProvider"
              [apFormGroup]="trackPatientResultsFilterForm" controlName="Provider"
              [additionalSearchParameters]="providerSearchParameters">
            </ap-findcontrol>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-referring-provider'" translate>Referring Provider</label>
            <ap-findcontrol [baseId]="baseId + '-referring-provider'" findControlId="ViewProvider"
              [apFormGroup]="trackPatientResultsFilterForm" controlName="ReferringProvider"
              [additionalSearchParameters]="referringProviderSearchParameters">
            </ap-findcontrol>
          </div>
        </div>

        <div class="emds-row">
          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-service-site'" translate>Service Site</label>
            <ap-findcontrol [baseId]="baseId + '-service-site'" findControlId="ListServiceSite"
              [apFormGroup]="trackPatientResultsFilterForm" controlName="ServiceSite"
              [additionalSearchParameters]="serviceSiteSearchParameters">
            </ap-findcontrol>
          </div>

          <div class="emds-col-12 emds-col-sm-6 emds-col-lg-3">
            <label [for]="baseId + '-procedure'" translate>Procedure</label>
            <ap-findcontrol [baseId]="baseId + '-procedure'" findControlId="ListProcedure"
              [apFormGroup]="trackPatientResultsFilterForm" controlName="Procedure">
            </ap-findcontrol>
          </div>
        </div>

        <div class="emds-row mt-3">
          <div class="emds-col-12 emds-col-md-6">
            <label translate>PSC</label>
            <mat-radio-group formControlName="PSC" class="radio-group">
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
              <mat-radio-button value="Both">Both</mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="emds-col-12 emds-col-md-6">
            <label translate>Future Orders</label>
            <mat-radio-group formControlName="FutureOrders" class="radio-group">
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
              <mat-radio-button value="Both">Both</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <hr class="margin-20">

        <div class="emds-row max-items-row">
          <div class="emds-col-12 emds-col-md-4">

            <label [for]="baseId + '-maximum-items-returned'" translate>
              Maximum Items Returned (-1 for no limit)
            </label>

            <input [id]="baseId + '-maximum-items-returned'" type="number" class="form-control"
              [ngClass]="{ error: showErrors(trackPatientResultsFilterForm.get('MaximumItemsReturned')!, isFormSubmitted) }"
              formControlName="MaximumItemsReturned" min="-1" max="10000">

            <div *ngIf="showErrors(trackPatientResultsFilterForm.get('MaximumItemsReturned')!, isFormSubmitted)"
              [id]="baseId + '-warning-text-maximum-items-returned'" class="incorrect-input" translate>
              <span *ngIf="trackPatientResultsFilterForm.get('MaximumItemsReturned')!.errors?.max">
                Maximum items should be less than or equal to 10000
              </span>
              <span *ngIf="trackPatientResultsFilterForm.get('MaximumItemsReturned')!.errors?.min">
                Maximum items should be greater than or equal to -1
              </span>
            </div>
          </div>

          <div class="emds-col-12 emds-col-md-4">
            <mat-checkbox [id]="baseId + '-include-strikeouts'" formControlName="IncludeStrikeouts" translate>
              Include Strikeouts
            </mat-checkbox>
          </div>

          <div class="emds-col-12 emds-col-md-4">
            <fc-filter-common [baseId]="baseId" [hideDefault]="hideDefault" [filterPermission$]="filterPermission$"
              [filterCommonFormGroup]="commonFilterForm"></fc-filter-common>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="submit" id="{{baseId}}-apply" class="btn btn-primary pull-right"
        (click)="submitType=FilterSubmitType.Apply" translate>
        Apply
      </button>

      <button type="submit" id="{{baseId}}-save" class="btn btn-light pull-right"
        (click)="submitType=FilterSubmitType.Save" translate>
        Save
      </button>

      <button type="submit" id="{{baseId}}-saveAs" class="btn btn-light pull-right"
        (click)="submitType=FilterSubmitType.SaveAs" translate>
        Save As
      </button>

      <button type="submit" class="btn btn-light" id="{{baseId}}-clear" (click)="submitType=FilterSubmitType.Clear"
        translate>Clear</button>

      <button type="button" id="{{baseId}}-cancel" class="btn btn-secondary pull-right" (click)="apUserCancel()"
        translate>
        Cancel
      </button>

    </div>
  </div>
</form>